import lodashGet from 'lodash/get';
import numeral from 'numeral';
import { useMemo } from 'react';
import { usePreferences } from '../context/PreferencesContext';
export function useFormatNumberByNucleus(nucleus) {
    const preferences = usePreferences();
    const nucleusByKey = lodashGet(preferences.current, `formatting.nuclei`, {
        ppm: '0.0',
        hz: '0.0',
    });
    return useMemo(() => {
        function formatFun(n) {
            return (value, formatKey = 'ppm', prefix = '', suffix = '') => {
                const formattedNumber = numeral(Number(value)).format(lodashGet(nucleusByKey, `${n.toLowerCase()}.${formatKey}`, '0.0'));
                return `${prefix}${formattedNumber}${suffix}`;
            };
        }
        if (!nucleus) {
            return () => undefined;
        }
        if (typeof nucleus === 'string') {
            return formatFun(nucleus);
        }
        else if (Array.isArray(nucleus)) {
            return nucleus.map((n) => formatFun(n));
        }
        else {
            throw new Error('nuclus must be string or array of string');
        }
    }, [nucleus, nucleusByKey]);
}
